import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import enTranslations from '../_locales/en.json';
import esTranslations from '../_locales/es.json';
import frTranslations from '../_locales/fr.json';
import deTranslations from '../_locales/de.json';
import ptTranslations from '../_locales/pt.json';
import itTranslations from '../_locales/it.json';
import zhTranslations from '../_locales/zh.json';
import jaTranslations from '../_locales/ja.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations },
      fr: { translation: frTranslations },
      de: { translation: deTranslations },
      pt: { translation: ptTranslations },
      it: { translation: itTranslations },
      zh: { translation: zhTranslations },
      ja: { translation: jaTranslations },
    },
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    }
  });

export default i18n;